// extracted by mini-css-extract-plugin
module.exports = {"queue":"Queue-module__queue___1mAke","card":"Queue-module__card___TttYG","noData":"Queue-module__noData___2sdUd","table":"Queue-module__table___1Pr6n"};